import { createFileRoute } from "@tanstack/react-router";

import LogoutPage from "~/pages/auth/LogoutPage.tsx";

export const Route = createFileRoute("/logout")({
    component: LogoutPage,
});
